module.exports = __webpack_public_path__ + "static/img/2_3_2.3ad0f0de.png";